import { render, staticRenderFns } from "./footer_img.vue?vue&type=template&id=3dbbb94a&scoped=true&"
import script from "./footer_img.vue?vue&type=script&lang=js&"
export * from "./footer_img.vue?vue&type=script&lang=js&"
import style0 from "./footer_img.vue?vue&type=style&index=0&id=3dbbb94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbbb94a",
  null
  
)

export default component.exports